import { useState, useEffect } from 'react';
import { onValue } from 'firebase/database';
import { serverTimeRef } from '../firebase/firebase';

export function useServerTime() {
    const [serverTime, setServerTime] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsLoading(true);

        const unsubscribe = onValue(serverTimeRef, (snapshot) => {
            try {
                const offset = snapshot.val();
                const currentServerTime = Date.now() + offset;
                setServerTime(currentServerTime);
                setIsLoading(false);
            } catch (error) {
                console.error('Error fetching server time:', error);
                setError(error);
                setServerTime(Date.now()); // 오류 시 로컬 시간 사용
                setIsLoading(false);
            }
        });

        return () => unsubscribe();
    }, []);

    // 현재 서버 시간을 가져오는 함수
    const getCurrentServerTime = () => {
        if (serverTime === null) return Date.now(); // 초기 로딩 중에는 로컬 시간 반환

        // 초기 설정된 serverTime에 경과 시간을 더함
        const offset = serverTime - Date.now();
        return Date.now() + offset;
    };

    return {
        serverTime,
        getCurrentServerTime,
        isLoading,
        error,
        getServerTimeISO: () => new Date(getCurrentServerTime()).toISOString()
    };
}